export default function (element, event) {

  const { left, right, top, bottom } = element.getBoundingClientRect()
  const { clientX, clientY } = event

  return (
      clientX < left ||
      clientX > right ||
      clientY < top ||
      clientY > bottom
  );
}